import React, { useState,useRef, useEffect } from 'react';
import './EmployeePortal.css';
import { useNavigate } from 'react-router-dom';
import HRCopilotFeatures from './HRCopilotFeatures';
import HRCopilotNewsSection from "./HRCopilotNewsSection";
import {
  FaUser,
  FaGraduationCap,
  FaBriefcase,
  FaFileAlt,
  FaPassport,
  FaUsers,
  FaChartLine,
  FaLaptop,
  FaUmbrellaBeach,
  FaClock,
  FaCalendarAlt,
  FaRocket,
  FaChartBar,
  FaCog,
  FaComments,
  FaSearch,
  FaFilter,
  FaTimes,
  FaArrowRight,
  FaBookmark,
  FaShare,
  FaEye,
  FaCalendar,
  FaTag,
  FaChevronRight,
  FaRocketchat
} from 'react-icons/fa';
import EmployeeHero from './EmployeeHero';
import EmployeeWiseCode from './EmployeeWiseCode';

const EmployeePortal = () => {
  const [selectedFeature, setSelectedFeature] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [activeCategory, setActiveCategory] = useState('all');
  const [sortBy, setSortBy] = useState('popular');
  const [showFilters, setShowFilters] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]);
  const [featuredSurvey, setFeaturedSurvey] = useState(0);
  const navigate = useNavigate();
 const videoRef = useRef(null);
  const [scrollY, setScrollY] = useState(0);
  const handleAccessRecruit = () => navigate('/payment');
  const handleRecruit = () => navigate('/access-recruit');

  // Categories for filtering
  const categories = [
    { id: 'all', name: 'All Features', icon: <FaRocket />, count: 14 },
    { id: 'personal', name: 'Personal Management', icon: <FaUser />, count: 3 },
    { id: 'professional', name: 'Professional Development', icon: <FaBriefcase />, count: 4 },
    { id: 'time', name: 'Time & Attendance', icon: <FaClock />, count: 3 },
    { id: 'collaboration', name: 'Team Collaboration', icon: <FaUsers />, count: 2 },
    { id: 'analytics', name: 'Performance Analytics', icon: <FaChartBar />, count: 2 }
  ];

  // All available tags
  const allTags = ['Management', 'Development', 'Collaboration', 'Analytics', 'HR', 'Productivity', 'Tracking', 'Reporting', 'Resources', 'Tools'];

  // Featured surveys (carousel)
  const featuredSurveys = [
    {
      id: 1,
      title: 'Q4 2024 Employee Engagement Survey',
      excerpt: 'Share your feedback on workplace culture, management effectiveness, and overall job satisfaction.',
      category: 'analytics',
      participants: '1,247',
      completionRate: '92%',
      averageScore: '4.2/5.0',
      closingDate: 'Jan 26, 2025',
      image: '/images/emp2.png',
      tags: ['Engagement', 'Feedback', 'Culture']
    },
    {
      id: 2,
      title: 'Professional Development Needs Assessment',
      excerpt: 'Help us understand your training needs and career development aspirations for the upcoming year.',
      category: 'professional',
      participants: '892',
      completionRate: '78%',
      averageScore: '4.0/5.0',
      closingDate: 'Feb 15, 2025',
      image: '/images/emp3.png',
      status: 'active',
      tags: ['Development', 'Training', 'Career']
    },
    {
      id: 3,
      title: 'Work-Life Balance & Wellness Check',
      excerpt: 'Provide insights on work-life balance, wellness programs, and overall workplace well-being.',
      category: 'personal',
      participants: '1,045',
      completionRate: '85%',
      averageScore: '4.3/5.0',
      closingDate: 'Mar 10, 2025',
      image: '/images/emp4.png',
      status: 'active',
      tags: ['Wellness', 'Balance', 'Health']
    }
  ];

  // Enhanced features data with detailed content for popups
  const features = [
    {
      id: 1,
      title: "Personal Details",
      description: "Manage and update your personal information, contact details, and emergency contacts in one secure location.",
      detailedContent: `
        <h3>Complete Personal Profile Management</h3>
        <p>Maintain up-to-date personal information including:</p>
        <ul>
          <li>Contact details and emergency contacts</li>
          <li>Personal identification documents</li>
          <li>Bank account information for payroll</li>
          <li>Tax-related information and declarations</li>
          <li>Family details and dependents information</li>
        </ul>
        <p><strong>Features:</strong> Secure data encryption, automatic update reminders, multi-device access</p>
      `,
      icon: <FaUser />,
      image: "https://media.istockphoto.com/id/2215068547/photo/business-strategies-and-competitive-advantage-banking-and-finance-the-path-to-success-goal.jpg?s=612x612&w=0&k=20&c=YgEKq3fFCpmPWqqXswih3ZszaydR4lpW7l42qSHWsXU=",
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      category: "personal",
      usage: "98%",
      satisfaction: "95%",
      tags: ['Management', 'HR', 'Personal']
    },
    {
      id: 2,
      title: "Academic Details", 
      description: "View and manage your educational qualifications, certifications, and professional development records.",
      detailedContent: `
        Comprehensive Academic Records
        <p>Track and manage all your educational achievements:</p>
        <ul>
          <li>Degree and diploma certificates</li>
          <li>Professional certifications and licenses</li>
          <li>Training programs and workshops</li>
          <li>Skill development courses</li>
          <li>Conference participations</li>
        </ul>
        <p><strong>Benefits:</strong> Automated verification, expiry alerts, career path suggestions</p>
      `,
      icon: <FaGraduationCap />,
      image: "https://media.istockphoto.com/id/1027407018/photo/tree-of-knowledge-growing-on-open-textbook-with-doodle-for-educational-investment-and-success.jpg?s=612x612&w=0&k=20&c=GcJbTI_GeOIzmeoG6hPlXzcIrpbI9LCsGihWj8iuXxg=",
      gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      category: "professional",
      usage: "95%",
      satisfaction: "96%",
      tags: ['Development', 'Education', 'Certification']
    },
    {
      id: 3,
      title: "Experience Details",
      description: "Track your professional experience, skills development, and career progression milestones.",
      detailedContent: `
        <h3>Professional Experience Tracking</h3>
        <p>Document your career journey and skill development:</p>
        <ul>
          <li>Previous employment history</li>
          <li>Project experiences and achievements</li>
          <li>Skill progression and competencies</li>
          <li>Career milestones and promotions</li>
          <li>Performance feedback and reviews</li>
        </ul>
        <p><strong>Tools:</strong> Timeline visualization, skill gap analysis, career growth projections</p>
      `,
      icon: <FaBriefcase />,
      image: "https://media.istockphoto.com/id/1336658193/photo/confident-young-man-working-on-computer.jpg?s=612x612&w=0&k=20&c=1KImp_XZMJy021hE_m8w017_woBjxCr60hD9o04QymQ=",
      gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
      category: "professional",
      usage: "92%",
      satisfaction: "94%",
      tags: ['Development', 'Career', 'Skills']
    },
    {
      id: 4,
      title: "Document Records",
      description: "Access and manage all your important documents with secure cloud storage and easy retrieval.",
      detailedContent: `
        <h3>Secure Document Management</h3>
        <p>Centralized repository for all your important documents:</p>
        <ul>
          <li>Contract agreements and offer letters</li>
          <li>Performance appraisal documents</li>
          <li>Training completion certificates</li>
          <li>Compliance and policy documents</li>
          <li>Personal development plans</li>
        </ul>
        <p><strong>Security:</strong> End-to-end encryption, access controls, version history</p>
      `,
      icon: <FaFileAlt />,
      image: "https://media.istockphoto.com/id/864602884/photo/data-transferring.jpg?s=612x612&w=0&k=20&c=_ahhhGaDlJHpU8F_ORtX1jAdlY-Ib42owL4MPR3RKj8=",
      gradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
      category: "personal",
      usage: "98%",
      satisfaction: "97%",
      tags: ['Management', 'Resources', 'Documents']
    },
    {
      id: 5,
      title: "Passport Details",
      description: "Store and manage passport, visa information, and travel documents with expiration alerts.",
      detailedContent: `
        <h3>Travel Document Management</h3>
        <p>Keep all your travel documents organized and up-to-date:</p>
        <ul>
          <li>Passport details and scans</li>
          <li>Visa information and expiry dates</li>
          <li>Work permit documents</li>
          <li>Travel insurance details</li>
          <li>Emergency contact information</li>
        </ul>
        <p><strong>Alerts:</strong> Automatic expiry notifications, renewal reminders, travel advisory updates</p>
      `,
      icon: <FaPassport />,
      image: "https://media.istockphoto.com/id/1393093359/photo/search-for-air-travel-information-air-ticket-booking-for-travel.jpg?s=612x612&w=0&k=20&c=vjx4BAdbvsa-6DNt8uO3VkAKsZ2eTyhJA6rBAe4zFig=",
      gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
      category: "personal",
      usage: "85%",
      satisfaction: "93%",
      tags: ['Management', 'Travel', 'Documents']
    },
    {
      id: 6,
      title: "My Team",
      description: "Connect with your team members, collaborate on projects, and share achievements together.",
      detailedContent: `
        <h3>Team Collaboration Hub</h3>
        <p>Enhanced team connectivity and collaboration features:</p>
        <ul>
          <li>Team member profiles and contact information</li>
          <li>Collaborative project workspaces</li>
          <li>Team announcements and updates</li>
          <li>Skill sharing and knowledge base</li>
          <li>Team performance metrics</li>
        </ul>
        <p><strong>Collaboration:</strong> Real-time messaging, file sharing, virtual meeting rooms</p>
      `,
      icon: <FaUsers />,
      image: "https://plus.unsplash.com/premium_photo-1661517335128-2bcf290d58f6?w=700&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fHRlYW13b3JrfGVufDB8fDB8fHww",
      gradient: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
      category: "collaboration",
      usage: "96%",
      satisfaction: "95%",
      tags: ['Collaboration', 'Team', 'Communication']
    },
    {
      id: 7,
      title: "Reporting Manager",
      description: "Communicate with your reporting manager, schedule meetings, and track performance feedback.",
      detailedContent: `
        <h3>Manager Communication Portal</h3>
        <p>Streamlined communication and feedback system:</p>
        <ul>
          <li>One-on-one meeting scheduling</li>
          <li>Performance feedback and reviews</li>
          <li>Goal setting and tracking</li>
          <li>Career development discussions</li>
          <li>Approval workflows and requests</li>
        </ul>
        <p><strong>Features:</strong> Automated meeting reminders, feedback templates, progress tracking</p>
      `,
      icon: <FaChartLine />,
      image: "https://media.istockphoto.com/id/2210166764/photo/two-asian-businessmen-talking-about-solar-energy-in-modern-meeting-room-asian-senior.webp?a=1&b=1&s=612x612&w=0&k=20&c=28G15ZNBXD76qAXApupe-zLqfbOiJDxW9gMh47UOEG8=",
      gradient: "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)",
      category: "collaboration",
      usage: "94%",
      satisfaction: "92%",
      tags: ['Management', 'Communication', 'Feedback']
    },
    {
      id: 8,
      title: "Allocated Items",
      description: "View company assets, equipment, and resources allocated to you with maintenance tracking.",
      detailedContent: `
        <h3>Asset and Resource Management</h3>
        <p>Complete overview of allocated company resources:</p>
        <ul>
          <li>Laptops and computer equipment</li>
          <li>Software licenses and subscriptions</li>
          <li>Office supplies and furniture</li>
          <li>Company vehicle allocations</li>
          <li>Mobile devices and accessories</li>
        </ul>
        <p><strong>Tracking:</strong> Maintenance schedules, warranty information, replacement alerts</p>
      `,
      icon: <FaLaptop />,
      image: "https://media.istockphoto.com/id/480743480/photo/responsive-design-mockup.jpg?s=612x612&w=0&k=20&c=347VwZ77QQ4byXRQetP4ids9SKC0aPQEWwsyFmjfNXw=",
      gradient: "linear-gradient(135deg, #8476e9 0%, #a379e6 100%)",
      category: "personal",
      usage: "89%",
      satisfaction: "91%",
      tags: ['Resources', 'Tools', 'Management']
    },
    {
      id: 9,
      title: "Leave Management",
      description: "Apply for leave, track balances, and manage time-off requests with automated approvals.",
      detailedContent: `
        <h3>Comprehensive Leave Management</h3>
        <p>Streamlined leave application and tracking system:</p>
        <ul>
          <li>Leave balance tracking and forecasting</li>
          <li>Online leave application and approval</li>
          <li>Holiday calendar integration</li>
          <li>Team availability overview</li>
          <li>Leave policy information</li>
        </ul>
        <p><strong>Automation:</strong> Auto-approval workflows, conflict detection, calendar sync</p>
      `,
      icon: <FaUmbrellaBeach />,
      image: "https://media.istockphoto.com/id/2228953367/photo/financial-analyst-calculates-medical-data-using-spreadsheet-on-laptop.webp?a=1&b=1&s=612x612&w=0&k=20&c=FMyVHNeWF34sm-BYgBv9cYiRuFbZyrIBLy8h4nTJKXo=",
      gradient: "linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)",
      category: "time",
      usage: "99%",
      satisfaction: "98%",
      tags: ['Management', 'Time', 'Productivity']
    },
    {
      id: 10,
      title: "Attendance Management",
      description: "Check your attendance records, working hours, and time tracking with detailed analytics.",
      detailedContent: `
        <h3>Advanced Attendance Tracking</h3>
        <p>Comprehensive attendance and time management:</p>
        <ul>
          <li>Daily attendance logging</li>
          <li>Working hours calculation</li>
          <li>Overtime tracking and approval</li>
          <li>Attendance pattern analytics</li>
          <li>Compliance reporting</li>
        </ul>
        <p><strong>Analytics:</strong> Attendance trends, pattern recognition, compliance alerts</p>
      `,
      icon: <FaClock />,
      image: "https://media.istockphoto.com/id/2216740947/photo/digital-calendar-interface-with-performance-metrics-displayed-on-hands-typing-at-laptop-desk.jpg?s=612x612&w=0&k=20&c=TMttgb9T53IowwG8FQWYE27nCxJY5yj2DNXzzo5vftY=",
      gradient: "linear-gradient(135deg, #a8c0ff 0%, #3f4c6b 100%)",
      category: "time",
      usage: "97%",
      satisfaction: "96%",
      tags: ['Tracking', 'Analytics', 'Productivity']
    },
    {
      id: 11,
      title: "Timesheet",
      description: "Log and manage your work hours, project time allocation, and weekly timesheet submissions.",
      detailedContent: `
        <h3>Project Time Tracking</h3>
        <p>Efficient timesheet management for project billing:</p>
        <ul>
          <li>Project-wise time logging</li>
          <li>Task-level time tracking</li>
          <li>Weekly timesheet submissions</li>
          <li>Approval workflow management</li>
          <li>Billing and invoicing integration</li>
        </ul>
        <p><strong>Integration:</strong> Project management tools, billing systems, payroll processing</p>
      `,
      icon: <FaCalendarAlt />,
      image: "https://media.istockphoto.com/id/526198773/photo/checking-the-shipping-calender.jpg?s=612x612&w=0&k=20&c=LpNEusKSNLdVrx2CbUyxXn3r5-_odnJMiW3lOfoDhNY=",
      gradient: "linear-gradient(135deg, #fdbb2d 0%, #22c1c3 100%)",
      category: "time",
      usage: "93%",
      satisfaction: "94%",
      tags: ['Tracking', 'Productivity', 'Reporting']
    },
    {
      id: 12,
      title: "Projects",
      description: "Manage your projects, tasks, deadlines, and collaborate with cross-functional teams.",
      detailedContent: `
        <h3>Project Management Suite</h3>
        <p>End-to-end project management capabilities:</p>
        <ul>
          <li>Project planning and scheduling</li>
          <li>Task assignment and tracking</li>
          <li>Milestone and deadline management</li>
          <li>Resource allocation and planning</li>
          <li>Progress reporting and analytics</li>
        </ul>
        <p><strong>Collaboration:</strong> Team workspaces, document sharing, real-time updates</p>
      `,
      icon: <FaRocket />,
      image: "https://media.istockphoto.com/id/1081869356/photo/taking-on-the-late-shift-with-true-dedication.jpg?s=612x612&w=0&k=20&c=6cd0XCc7SXbwh3gDTDgg7yjljBPbW8gAmUUmDCQqs9E=",
      gradient: "linear-gradient(135deg, #ff6b6b 0%, #ffa8a8 100%)",
      category: "collaboration",
      usage: "91%",
      satisfaction: "93%",
      tags: ['Collaboration', 'Productivity', 'Tools']
    },
    {
      id: 13,
      title: "Performance",
      description: "Access performance tools, track goals, and manage your career development progress.",
      detailedContent: `
        <h3>Performance Management System</h3>
        <p>Comprehensive performance tracking and development:</p>
        <ul>
          <li>Goal setting and tracking</li>
          <li>Performance reviews and appraisals</li>
          <li>Skill assessment and development</li>
          <li>Career progression planning</li>
          <li>Feedback and coaching</li>
        </ul>
        <p><strong>Development:</strong> Personalized learning paths, competency mapping, growth opportunities</p>
      `,
      icon: <FaChartBar />,
      image: "https://media.istockphoto.com/id/2208274645/photo/human-resource-evaluation-and-performance-appraisal-employee-talent-assessment-and-competency.jpg?s=612x612&w=0&k=20&c=LIMQ1p-QnPc1X6lmLKlWywMsWzHCQsHaDZ4fT_3Oamc=",
      gradient: "linear-gradient(135deg, #74ebd5 0%, #9face6 100%)",
      category: "analytics",
      usage: "95%",
      satisfaction: "94%",
      tags: ['Analytics', 'Development', 'Performance']
    },
    {
      id: 14,
      title: "Meetings",
      description: "Schedule, manage, and track meetings with integrated calendar and collaboration tools.",
      detailedContent: `
        <h3>Meeting Management Platform</h3>
        <p>Efficient meeting scheduling and management:</p>
        <ul>
          <li>Meeting scheduling and calendar integration</li>
          <li>Agenda creation and distribution</li>
          <li>Attendance tracking and minutes</li>
          <li>Action item tracking and follow-up</li>
          <li>Virtual meeting support</li>
        </ul>
        <p><strong>Productivity:</strong> Automated reminders, template library, integration with collaboration tools</p>
      `,
      icon: <FaComments />,
      image: "https://media.istockphoto.com/id/1300311961/photo/business-meeting-on-video-call-during-covid-19-lockdown.jpg?s=612x612&w=0&k=20&c=t33GlkSVBqQT1GAogvFUvj0uhkya8PfisKEKGnbnvBg=",
      gradient: "linear-gradient(135deg, #d299c2 0%, #fef9d7 100%)",
      category: "collaboration",
      usage: "96%",
      satisfaction: "95%",
      tags: ['Collaboration', 'Communication', 'Productivity']
    }
  ];

  // Filter features based on search, category, tags, and sort
  const filteredFeatures = features
    .filter(feature => {
      const matchesSearch = searchQuery === '' || 
        feature.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        feature.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
        feature.tags.some(tag => tag.toLowerCase().includes(searchQuery.toLowerCase()));

      const matchesCategory = activeCategory === 'all' || feature.category === activeCategory;
      
      const matchesTags = selectedTags.length === 0 || 
        selectedTags.every(tag => feature.tags.includes(tag));

      return matchesSearch && matchesCategory && matchesTags;
    })
    .sort((a, b) => {
      switch (sortBy) {
        case 'popular':
          return parseInt(b.usage) - parseInt(a.usage);
        case 'satisfaction':
          return parseInt(b.satisfaction) - parseInt(a.satisfaction);
        case 'alphabetical':
          return a.title.localeCompare(b.title);
        default:
          return 0;
      }
    });

  // Update category counts based on filtered features
  useEffect(() => {
    categories.forEach(cat => {
      if (cat.id !== 'all') {
        cat.count = features.filter(feature => 
          feature.category === cat.id && 
          (searchQuery === '' || 
           feature.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
           feature.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
           feature.tags.some(tag => tag.toLowerCase().includes(searchQuery.toLowerCase())))
        ).length;
      } else {
        cat.count = features.filter(feature => 
          searchQuery === '' || 
          feature.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
          feature.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
          feature.tags.some(tag => tag.toLowerCase().includes(searchQuery.toLowerCase()))
        ).length;
      }
    });
  }, [searchQuery]);

  const nextFeaturedSurvey = () => {
    setFeaturedSurvey((prev) => (prev + 1) % featuredSurveys.length);
  };

  const prevFeaturedSurvey = () => {
    setFeaturedSurvey((prev) => (prev - 1 + featuredSurveys.length) % featuredSurveys.length);
  };

  const handleLearnMore = (feature) => {
    setSelectedFeature(feature);
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
    setSelectedFeature(null);
  };

  const handleTagClick = (tag) => {
    if (selectedTags.includes(tag)) {
      setSelectedTags(selectedTags.filter(t => t !== tag));
    } else {
      setSelectedTags([...selectedTags, tag]);
    }
  };

  const clearAllFilters = () => {
    setSearchQuery('');
    setActiveCategory('all');
    setSelectedTags([]);
    setSortBy('popular');
  };

  const FeatureModal = ({ feature, onClose }) => (
  <div className="portal__modal-overlay" onClick={onClose}>
    <div className="portal__modal-content" onClick={(e) => e.stopPropagation()}>
      <button className="portal__modal-close" onClick={onClose}>
        <FaTimes />
      </button>
      
      <div className="portal__modal-header">
        <div className="portal__modal-image-container">
          <img src={feature.image} alt={feature.title} className="portal__modal-image" />
          <div className="portal__modal-overlay-gradient"></div>
        </div>
        <div className="portal__modal-meta">
          <span className="portal__modal-category">{feature.category}</span>
          <h2 className="portal__modal-title">{feature.title}</h2>
          <div className="portal__modal-stats">
            <span><FaEye /> {feature.usage}% Usage</span>
            <span>⭐ {feature.satisfaction}% Satisfaction</span>
          </div>
        </div>
      </div>
      
      <div className="portal__modal-body">
        <div className="portal__feature-content">
          {/* Parse and render HTML content properly */}
          {(() => {
            const content = feature.detailedContent;
            const lines = content.split('\n').filter(line => line.trim() !== '');
            
            return lines.map((line, index) => {
              if (line.includes('<h3>')) {
                return <h3 key={index} className="portal__content-heading" dangerouslySetInnerHTML={{ __html: line.replace(/<h3>|<\/h3>/g, '') }} />;
              } else if (line.includes('<p>')) {
                return <p key={index} className="portal__content-paragraph" dangerouslySetInnerHTML={{ __html: line.replace(/<p>|<\/p>/g, '') }} />;
              } else if (line.includes('<ul>')) {
                return null; // Skip ul tag itself
              } else if (line.includes('<li>')) {
                return (
                  <li key={index} className="portal__content-list-item">
                    {line.replace(/<li>|<\/li>/g, '')}
                  </li>
                );
              } else if (line.includes('<strong>')) {
                return (
                  <p key={index} className="portal__content-strong">
                    <strong>{line.replace(/<strong>|<\/strong>/g, '')}</strong>
                  </p>
                );
              } else if (line.trim() === '') {
                return <br key={index} />;
              } else {
                return <p key={index} className="portal__content-paragraph">{line}</p>;
              }
            });
          })()}
        </div>
      </div>
      
      <div className="portal__modal-footer">
        <div className="portal__modal-tags">
          {feature.tags.map(tag => (
            <span key={tag} className="portal__feature-tag">
              <FaTag />
              {tag}
            </span>
          ))}
        </div>
        <div className="portal__modal-actions">
          <button className="portal__action-btn portal__action-btn--primary" onClick={handleRecruit}>
            <FaRocketchat /> Access Feature
          </button>
          <button className="portal__action-btn">
            <FaBookmark /> Save
          </button>
        </div>
      </div>
    </div>
  </div>
);

  return (
    <div className="portal">
      {/* Feature Modal */}
      {selectedFeature && (
        <FeatureModal feature={selectedFeature} onClose={handleClosePopup} />
      )}

     <EmployeeHero/>
     <EmployeeWiseCode/> 
     <HRCopilotFeatures/>
     <HRCopilotNewsSection/>
     

   
    </div>
  );
};

export default EmployeePortal;